// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__xruZj","label":"Category_label__2lbtw","content":"Category_content__1UK5Q","header":"Category_header__3Da3B","location":"Category_location__jUSdM"};